if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}




//card thambainals 

// document.addEventListener('DOMContentLoaded', function() {
//   console.log('DOM fully loaded and parsed.');

//   const collectionCards = document.querySelectorAll('.card-wrapper');
//   console.log('Found collection cards:', collectionCards);

//   collectionCards.forEach(card => {
//     const thumbnailButtons = card.querySelectorAll('.card_tumbainal .product-thumbnail-button');
//     console.log('  Found thumbnail buttons for a card:', thumbnailButtons);

//     if (thumbnailButtons.length > 0) {
//       thumbnailButtons.forEach(button => {
//         console.log('    Adding event listeners to button:', button);
//         button.addEventListener('mouseenter', function() {
//           console.log('      Mouse entered thumbnail:', this);

//           // Corrected selector for mainProductImage
//           const mainProductImage = this.closest('.card-wrapper').querySelector('.card__inner > .card__media .media > img');
//           const mainImageContainer = this.closest('.card-wrapper').querySelector('.card__inner > .card__media .media');

//           if (mainProductImage) {
//             const newImageSrc = this.querySelector('img').getAttribute('src');
//             console.log('      newImageSrc:', newImageSrc);
//             mainProductImage.setAttribute('src', newImageSrc);

//             const newImageSrcset = this.querySelector('img').getAttribute('srcset');
//             console.log('      newImageSrcset:', newImageSrcset);
//             if (newImageSrcset) {
//               mainProductImage.setAttribute('srcset', newImageSrcset);
//             }
//             console.log('      Main product image src and srcset updated.');
//           } else {
//             console.log('      mainProductImage NOT found in this card!');
//           }

//           if (mainImageContainer) {
//             mainImageContainer.classList.add('circular-main-image');
//             console.log('      "circular-main-image" class added to main image container.');
//           } else {
//             console.log('      mainImageContainer NOT found in this card!');
//           }
//         });

//         button.addEventListener('mouseleave', function() {
//           console.log('      Mouse left thumbnail:', this);
//           const mainImageContainer = this.closest('.card-wrapper').querySelector('.card__inner > .card__media .media');
//           if (mainImageContainer) {
//             mainImageContainer.classList.remove('circular-main-image');
//             console.log('      "circular-main-image" class removed from main image container.');
//           }
//         });
//       });

//       // Set the initial main image to the first thumbnail
//       const firstThumbnail = thumbnailButtons[0];
//       const mainProductImage = card.querySelector('.card__inner > .card__media .media > img'); // Updated selector here too
//       const mainImageContainer = card.querySelector('.card__inner > .card__media .media');

//       if (firstThumbnail && mainProductImage && mainImageContainer) {
//         console.log('  Setting initial main image from first thumbnail for this card.');
//         const firstImageSrc = firstThumbnail.querySelector('img').getAttribute('src');
//         mainProductImage.setAttribute('src', firstImageSrc);
//         const firstImageSrcset = firstThumbnail.querySelector('img').getAttribute('srcset');
//         if (firstImageSrcset) {
//           mainProductImage.setAttribute('srcset', firstImageSrcset);
//         }
//         mainImageContainer.classList.add('circular-main-image');
//         console.log('  Initial main image set and "circular-main-image" class added.');
//       } else {
//         console.log('  Could not set initial main image for this card (elements not found).');
//       }

//     } else {
//       console.log('  No thumbnail buttons found for this card.');
//     }
//   });
// });
// end card thambnails